import * as React from "react";
const InvoiceIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    viewBox="0 0 140 140"
    fill="none"
    {...props}
  >
    <path
      d="M28.8306 119.583C26.4243 119.583 24.4205 118.782 22.8192 117.181C21.2177 115.579 20.417 113.576 20.417 111.169V28.8301C20.417 26.4238 21.2177 24.42 22.8192 22.8187C24.4205 21.2173 26.4243 20.4165 28.8306 20.4165H58.2889C58.7824 17.5747 60.1229 15.219 62.3104 13.3494C64.4979 11.4798 67.0612 10.5449 70.0002 10.5449C72.9578 10.5449 75.5257 11.4798 77.7038 13.3494C79.8821 15.219 81.218 17.5747 81.7115 20.4165H111.17C113.576 20.4165 115.58 21.2173 117.181 22.8187C118.783 24.42 119.583 26.4238 119.583 28.8301V111.169C119.583 113.576 118.783 115.579 117.181 117.181C115.58 118.782 113.576 119.583 111.17 119.583H28.8306ZM28.8306 112.964H111.17C111.619 112.964 112.03 112.777 112.404 112.404C112.778 112.03 112.965 111.618 112.965 111.169V28.8301C112.965 28.3813 112.778 27.9699 112.404 27.5959C112.03 27.222 111.619 27.035 111.17 27.035H100.513V34.8876C100.513 36.0794 100.112 37.0785 99.3096 37.8849C98.5076 38.6911 97.5138 39.0943 96.3282 39.0943H43.6708C42.4853 39.0943 41.4918 38.6911 40.6902 37.8849C39.8885 37.0785 39.4876 36.0794 39.4876 34.8876V27.035H28.8306C28.3818 27.035 27.9704 27.222 27.5964 27.5959C27.2225 27.9699 27.0355 28.3813 27.0355 28.8301V111.169C27.0355 111.618 27.2225 112.03 27.5964 112.404C27.9704 112.777 28.3818 112.964 28.8306 112.964ZM70.01 27.7082C71.5066 27.7082 72.7578 27.202 73.7637 26.1895C74.7697 25.1771 75.2726 23.9226 75.2726 22.426C75.2726 20.9293 74.7664 19.6781 73.7539 18.6722C72.7415 17.6663 71.487 17.1634 69.9904 17.1634C68.4938 17.1634 67.2425 17.6696 66.2367 18.682C65.2307 19.6945 64.7277 20.949 64.7277 22.4456C64.7277 23.9423 65.234 25.1935 66.2464 26.1994C67.2589 27.2053 68.5134 27.7082 70.01 27.7082Z"
      fill="url(#paint0_linear_2402_15646)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2402_15646"
        x1={119.583}
        y1={23.6178}
        x2={3.51596}
        y2={53.1982}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41B0F8" />
        <stop offset={0.505208} stopColor="#626DFD" />
        <stop offset={1} stopColor="#7232FB" />
      </linearGradient>
    </defs>
  </svg>
);
export default InvoiceIcon;
